enum HoldReason {
  'INTERNAL' = 'Internal',
  'EXTERNAL' = 'External',
}

export { HoldReason }
